import type { QueryFunctionContext } from '@tanstack/react-query';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { asrProxyKeys } from 'app/queries/asrProxy/asrProxyKeys';
import type { TCall } from 'app/queries/types/TCall';
import { AsrProxyService } from './AsrProxyService';

type TParams = QueryFunctionContext<ReturnType<typeof asrProxyKeys.transcription>>;

export const createFetchAsrTranscriptionQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ transcriptionId }], signal }: TParams) =>
    call(() => cancelOnSignal(AsrProxyService.retrieveTranscription(transcriptionId), signal), {
      dontCatchErrors: true,
    });
